import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { ProfileDTO } from '../model/user-profiles-model';
import { UserProfilesStore } from '../user-profiles-service/user-profiles-service.store';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'sf-create-profile',
  templateUrl: './create-profile.component.html',
  styleUrls: ['./create-profile.component.scss'],
})
export class CreateProfileComponent implements OnInit {
  dataSourceProfiles = new MatTableDataSource<ProfileDTO>();
  displayedColumnsProfiles: string[] = ['name'];

  constructor(
    public translateService: TranslateService,
    private userProfilesStore: UserProfilesStore,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  saveProfile(selectionProfile: ProfileDTO) {
    this.userProfilesStore.createProfile(selectionProfile).subscribe((result) => {
      if (result) {
        this.userProfilesStore.getListProfiles().then(
          (data) => {
            this.dataSourceProfiles.data = data;
            const dialogConfig = new MatDialogConfig();
            dialogConfig.width = '90%';
            dialogConfig.maxWidth = '550px';
            dialogConfig.data = {
              text: this.translateService.instant('dialog.userProfiles.response.success').toUpperCase(),
              icon: 'icon-ic_circle_check',
              noRedirect: true,
            };
            setTimeout(() => {
              window.scrollTo(0, 0);
              this.dialog.open(ResponseDialogComponent, dialogConfig);
            }, 0);
          },
          (error) => console.error(error)
        );
      }
    });
  }
}
